exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.signature-pad {\n    width: 100%;\n    height: 300px;\n    border: 1px solid #ddd;\n}\n", ""]);

// exports
